module.exports = __webpack_public_path__ + "static/key-genesisalpha-b82455361941a671a6bae38b815a6987.webp";